<template>
  <label>
    Select Product Form:

    <select v-model="selectedProduct" @change="$emit('input', selectedProduct)">
      <option :value="{}" disabled selected>
        Product Form
      </option>

      <option v-for="product in products" :key="product.name" :value="product">
        {{ product.name }}
      </option>
    </select>
  </label>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data: function() {
    return {
      selectedProduct: {},
      products: [
        {
          name: "Round Bar",
          type: "round",
          image: "round",
          lengthToleranceDimension: "diameter"
        },
        {
          name: "Wire",
          type: "round",
          image: "wire",
          lengthToleranceDimension: "diameter"
        },
        {
          name: "Hex Bar",
          type: "hex",
          image: "hex"
        },
        {
          name: "Block",
          type: "flat",
          image: "block",
          lengthToleranceDimension: "thickness"
        },
        {
          name: "Plate",
          type: "flat",
          image: "flat",
          lengthToleranceDimension: "thickness"
        },
        {
          name: "Rectangular Bar",
          type: "rectangle",
          image: "flat",
          lengthToleranceDimension: "thickness"
        },
        {
          name: "Sheet",
          type: "flat",
          image: "flat",
          lengthToleranceDimension: "thickness"
        },
        {
          name: "Hollow Bar",
          type: "hollow",
          image: "hollow"
        },
        {
          name: "Seamless Pipe",
          type: "tube",
          image: "tube"
        },
        {
          name: "Welded Pipe",
          type: "tube",
          image: "tube"
        },
        {
          name: "Seamless Tube",
          type: "tube",
          image: "tube"
        },
        {
          name: "Welded Tube",
          type: "tube",
          image: "tube"
        }
      ]
    };
  }
};
</script>
